const COMPANY_NAME = process.env.REACT_APP_COMPANY_NAME ?? "Tu Empresa";
const COMPANY_ADDR = process.env.REACT_APP_COMPANY_REGISTERED_ADDRESS ?? "Tu dirección registrada";
const COMPANY_NO   = process.env.REACT_APP_COMPANY_REGISTERED_NUMBER ?? "00000000";
const SUPPORT_EMAIL= process.env.REACT_APP_SUPPORT_EMAIL ?? "soporte@ejemplo.com";

export const B2CES = `
<h2>Aviso de Privacidad — Reservas con {{BUSINESS_NAME}}</h2>

<p><strong>Responsable del tratamiento</strong><br>
{{BUSINESS_NAME}} es el responsable de los datos personales que proporcionas al realizar una reserva con nosotros.</p>

<p><strong>Contacto</strong><br>
Si tienes preguntas o deseas ejercer tus derechos de privacidad, contacta con nosotros en:<br>
Correo electrónico: <a href="mailto:{{BUSINESS_EMAIL}}">{{BUSINESS_EMAIL}}</a><br>
<em>Podemos colaborar con nuestro proveedor del sistema de reservas para atender tu solicitud.</em></p>

<h4>Qué datos recopilamos</h4>
<ul>
  <li>Identidad y contacto: nombre, dirección de correo electrónico y (si lo proporcionas) número de teléfono.</li>
  <li>Detalles de la reserva: servicio elegido, fecha/hora, miembro del personal y cualquier nota que añadas.</li>
  <li>Datos técnicos básicos: dirección IP e información del dispositivo/navegador necesaria por motivos de seguridad y para mostrar el formulario.</li>
  <li><strong>Pagos:</strong> si se requiere pago al reservar, los datos se introducen directamente en <strong>Stripe</strong>. No vemos ni almacenamos los datos completos de tu tarjeta.</li>
</ul>

<h4>Por qué usamos tus datos (bases legales)</h4>
<ul>
  <li>Para crear y gestionar tu reserva y prestar el servicio solicitado — <strong>Ejecución de un contrato</strong>.</li>
  <li>Para enviarte mensajes de servicio (confirmaciones, recordatorios, cambios, cancelaciones) y proteger nuestros servicios frente a usos indebidos o fraude — <strong>Interés legítimo</strong>.</li>
</ul>

<h4>Con quién compartimos tus datos</h4>
<ul>
  <li>Nuestro proveedor del sistema de reservas (encargado del tratamiento), que aloja esta página de reservas y envía correos electrónicos de servicio en nuestro nombre.</li>
  <li><strong>Stripe</strong> (procesador de pagos) si se requiere pago al reservar. Stripe es responsable de los datos de la tarjeta y conserva los comprobantes/transacciones según sus propias políticas.</li>
  <li>Proveedores de correo electrónico, TI y alojamiento, según sea necesario para operar nuestros servicios.</li>
</ul>

<h4>Transferencias internacionales</h4>
<ul>
<li>Algunos proveedores (por ejemplo, Stripe o la infraestructura de correo electrónico) pueden procesar datos fuera del Reino Unido/EEE. Se utilizan salvaguardas aprobadas, como las Cláusulas Contractuales Tipo de la UE y/o el Addendum/IDTA del Reino Unido.</li>
</ul>

<h4>Plazo de conservación</h4>
<ul>
  <li>Reservas y notas relacionadas: se conservan durante <strong>24 meses</strong> desde la fecha de la cita y luego se <strong>eliminan permanentemente</strong> (incluidos los registros de pago de esa cita almacenados en el sistema de reservas).</li>
  <li>Perfil del cliente (tus datos de contacto en el sistema de reservas): si no hay <strong>nuevas reservas ni ediciones en 24 meses</strong>, el registro se <strong>elimina permanentemente</strong>. Si vuelves a reservar, se te tratará como nuevo cliente.</li>
  <li>Metadatos técnicos/de entrega de correos de servicio (no el contenido del mensaje): se conservan durante <strong>30 días</strong> y luego se eliminan.</li>
  <li>Registros de acceso/seguridad: se conservan durante <strong>30 días</strong> y luego se eliminan.</li>
  <li>Copias de seguridad: se conservan durante un máximo de <strong>30 días</strong> y luego expiran automáticamente.</li>
  <li>Recibos/transacciones de pago: <strong>almacenados por Stripe</strong> según sus obligaciones legales y políticas de conservación.</li>
</ul>

<h4>Cookies</h4>
<ul>
<li>Esta página de reservas solo utiliza las cookies estrictamente necesarias para mostrar y proteger el formulario. No se utilizan cookies analíticas por defecto.</li>
</ul>

<h4>Datos de categoría especial</h4>
<ul>
<li>Por favor, no incluyas información de salud ni otros datos sensibles en las notas de texto libre; no los necesitamos para gestionar tu reserva.</li>
</ul>

<h4>Tus derechos</h4>
<ul>
<li>Puedes solicitar acceso, rectificación, supresión, limitación, portabilidad u oponerte a determinados tratamientos.
Para ejercer tus derechos, contacta con <a href="mailto:{{BUSINESS_EMAIL}}">{{BUSINESS_EMAIL}}</a>. Atenderemos tu solicitud y, si es necesario, colaboraremos con nuestro proveedor del sistema de reservas para gestionarla.</li>
</ul>

<h4>Reclamaciones</h4>
<ul>
<li>Si no estás satisfecho, puedes presentar una reclamación ante tu autoridad local de protección de datos (en el Reino Unido: la ICO; en España: la AEPD).</li>
</ul>
`;
